import { AxiosRequest } from "../common/axios-request"
import { CREATE_PROMOTIONAL_OFFER, DELETE_PROMOTIONAL_OFFER, GET_PROMOTIONAL_OFFERS_LIST, GET_PROMOTIONAL_OFFER_DETAILS, UPDATE_PROMOTIONAL_OFFER } from "../common/constant"

const GetPromotionalOffersList = () => {
    return AxiosRequest.get(GET_PROMOTIONAL_OFFERS_LIST)
}

const GetPromotionalOffersDetails = (id: string) => {
    return AxiosRequest.get(GET_PROMOTIONAL_OFFER_DETAILS.replace(":id", id))
}

const CreatePromotionalOffer = (payload: any) => {
    return AxiosRequest.post(CREATE_PROMOTIONAL_OFFER, payload)
}

const UpdatePromotionalOffer = (id: string, payload: any) => {
    return AxiosRequest.put(UPDATE_PROMOTIONAL_OFFER.replace(":id", id), payload)
}

const DeletePromotionalOffer = (id: string) => {
    return AxiosRequest.delete(DELETE_PROMOTIONAL_OFFER.replace(":id", id))
}

export { GetPromotionalOffersList, GetPromotionalOffersDetails, CreatePromotionalOffer, UpdatePromotionalOffer, DeletePromotionalOffer }